import { render, staticRenderFns } from "./view.html?vue&type=template&id=3082ec76&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=3082ec76&lang=less&scoped=true&"
import style1 from "./style_notebook.less?vue&type=style&index=1&id=3082ec76&lang=less&scoped=true&"
import style2 from "./style_mobile.less?vue&type=style&index=2&id=3082ec76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3082ec76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3082ec76')) {
      api.createRecord('3082ec76', component.options)
    } else {
      api.reload('3082ec76', component.options)
    }
    module.hot.accept("./view.html?vue&type=template&id=3082ec76&scoped=true&", function () {
      api.rerender('3082ec76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/rolls/index.vue"
export default component.exports